module.exports = __webpack_public_path__ + "img/default_profile.58ac64bb.png";